import { HttpContextToken } from '@angular/common/http';
import { KindOfLoader } from '../models';

export const LOADER_TOKEN = new HttpContextToken<KindOfLoader>(() => 'primary');
